<div class="navBar">
    <div class="navBar-btn">
        <button (click)="backToTransaction()"
            class="backToReport"><mat-icon>keyboard_arrow_left</mat-icon>
            <span>{{reportService.isProjectDetailOpen() ? ('User.Back'|translate) : ('reports.backToReport'|translate)}}</span> </button>
    </div>

    <div class="property-detailMenu" [ngClass]="{ 'property-detailMenuAr' : currentReportView === 2}">
        <app-report-sub-menu [menuList]="overViewMenu" [isPropertyDetailPage]="true"
            (menuChangeValue)="menuChangeValue($event)"></app-report-sub-menu>
    </div>
</div>

<div class="report-property-detail">
    <!-- <div class="report-tabsection-d" id="{{ propertyDetailMenuEnum.overview}}"
    [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.overview}">
      <app-property-details-overview [Property_Uid]="propertyInfo?.property_uid" [property_cat]="'multi_story_residential'"></app-property-details-overview>
    </div>
    <ng-container *ngIf="showPropertyInfomation">
        <div class="report-tabsection-d" id="{{ propertyDetailMenuEnum.propertyInformation}}"
        [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.propertyInformation}">
            <app-report-property-info [propertyInfo]="propertyInfo" (isEmpatyCheck)="viewSection($event, 'PropertyInfomation')"></app-report-property-info>
        </div>
    </ng-container> -->


    <!--Built up Information-->
      <!-- <ng-container *ngIf="showBuildUpinfo">
        <div class="report-tabsection-d" id="{{ propertyDetailMenuEnum.builtInformation}}"
            [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.builtInformation}">
            <app-build-up-info [propertyInfo]="propertyInfo" (isEmpatyCheck)="viewSection($event, 'BuildUpInfo')"></app-build-up-info>
        </div>
    </ng-container> -->
    <!--Built up Information-->


    <!--Construction-->
    <!-- <div id="{{ propertyDetailMenuEnum.costOfconstruction}}">
        <app-cost-of-construction [propertyInfo]="propertyInfo"></app-cost-of-construction>

    </div> -->

    <!--Construction-->

    <!--Amenities-->
    <!-- <ng-container  *ngIf="showAmenities">
        <div class="report-tabsection-d" id="{{ propertyDetailMenuEnum.amentities}}"
            [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.amentities}">
            <app-property-amenities [propertyInfo]="propertyInfo" (isEmpatyCheck)="viewSection($event,'Amenities')"></app-property-amenities>
        </div>
    </ng-container> -->
    <!--Amenities-->

    <!--Residential Units a-->
    <!-- <ng-container *ngIf="showResidentialUnits">
        <div class="report-tabsection-d" id="{{ propertyDetailMenuEnum.unit}}"
            [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.unit}">

            <app-residential-units [propertyInfo]="propertyInfo" (isEmpatyCheck)="viewSection($event,'ResidentialUnits')"></app-residential-units>


        </div>
    </ng-container> -->
    <!--Residential Units-->

    <!-- land-value-details -->
     <!-- <ng-container *ngIf="showLandDetails">
        <app-land-value-details [propertyInfo]="propertyInfo" (isEmpatyCheck)="viewSection($event,'LandDetails')"></app-land-value-details>
    </ng-container> -->
    <!-- land-value-details -->

    <!-- Units Trasaction b-->
     <!-- <ng-container>
        <div class="report-model report-tabsection-d" id="{{ propertyDetailMenuEnum.unitTransaction}}"
            [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.unitTransaction}">

            <app-unit-transaction [propertyInfo]="propertyInfo"></app-unit-transaction>
        </div>
        </ng-container> -->
    <!--Units Trasaction-->

    <!-- Property Transaction propertyTransaction-->

    <!-- <ng-container>
        <div class="report-model report-tabsection-d" id="{{ propertyDetailMenuEnum.propertyTransaction}}"
        [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.propertyTransaction}">
        <app-property-transaction [propertyInfo]="propertyInfo" [report_category]="propertyCategory.MultiStoryResidential"
        ></app-property-transaction>
    </div>
    </ng-container> -->
    <!-- Property Transaction End-->

    <!-- residentail Income Assessment Start d -->
    <!-- <ng-container *ngIf="showResidentailIncome">
        <div class="report-model report-tabsection-d" id="{{ propertyDetailMenuEnum.rentalIncome}}"
            [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.rentalIncome}">
            <app-residential-rentalincome-assessement [propertyInfo]="propertyInfo"
            (isEmpatyCheck)="viewSection($event,'ResidentailIncome')"></app-residential-rentalincome-assessement>
        </div>
    </ng-container> -->
    <!-- residentail Income Assessment End -->

    <!-- Commercial Rental Income Assessment Start e-->
    <!-- <ng-container *ngIf="showCommercialIncome">
        <div class="report-model report-tabsection-d" id="{{ propertyDetailMenuEnum.commercialRentalIncome}}"
            [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.commercialRentalIncome}">
            <app-commercial-rental-income-assessment [propertyInfo]="propertyInfo"
            (isEmpatyCheck)="viewSection($event,'CommercialIncome')"></app-commercial-rental-income-assessment>
        </div>
    </ng-container> -->
    <!-- Commercial Rental Income Assessment End -->

    <!-- Nearby rental and occupancy Start f-->
    <!-- <ng-container *ngIf="showNearbyRental">
        <div class="report-model report-tabsection-d" id="{{ propertyDetailMenuEnum.NearByRentalAndOccupancy}}"
            [ngClass]="{ 'scroll': currentScroll === propertyDetailMenuEnum.NearByRentalAndOccupancy}">
        <app-nearby-rentals-and-occupancy [propertyInfo]="propertyInfo"
        (isEmpatyCheck)="viewSection($event,'NearbyRental')"></app-nearby-rentals-and-occupancy>
        </div>
    </ng-container> -->
     <!-- Nearby rental and occupancy End -->

</div>
